import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

const DocsLanding = () => {
  const navigate = useNavigate();

  const docs = [
    {
      route: "/docs/editor",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-7 h-7"
          style={{ color: "#FFF528" }}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={1.5}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3.75 9.75h16.5M3.75 12h16.5m-16.5 2.25h16.5M3.375 4.5h17.25A1.125 1.125 0 0121.75 5.625v12.75A1.125 1.125 0 0120.625 19.5H3.375A1.125 1.125 0 012.25 18.375V5.625A1.125 1.125 0 013.375 4.5z"
          />
        </svg>
      ),
      badge: "For Editors",
      title: "Editor Guide",
      description:
        "Learn how to review, filter, and export user-submitted videos inside the Vault — your primary workspace.",
      features: [
        "Getting Started with the Vault",
        "Clips Timeline & Filters",
        "Viewing, Rating & Editing Clips",
        "Export Settings & History",
        "Community Events & Q Cards",
      ],
      cta: "Open Editor Guide",
    },
    {
      route: "/docs/manager",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-7 h-7"
          style={{ color: "#FFF528" }}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={1.5}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"
          />
        </svg>
      ),
      badge: "For Broadcasters",
      title: "Broadcaster Guide",
      description:
        "Manage your team, control budgets, configure the platform, and maintain full oversight of your broadcast operations.",
      features: [
        "User Roles & Permissions",
        "Inviting Editors, Managers & Shooters",
        "Budget Allocation & Billing",
        "Brand & Export Configuration",
        "Monitoring & Export Oversight",
      ],
      cta: "Open Broadcaster Guide",
    },
  ];

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ backgroundColor: "black" }}
    >
      <Navbar/>
      {/* Ambient background — yellow tint only, very subtle */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        <div
          className="absolute top-0 left-1/3 w-[500px] h-[500px] rounded-full blur-[140px]"
          style={{ background: "rgba(255,245,40,0.03)" }}
        />
        <div
          className="absolute bottom-1/4 right-1/3 w-[400px] h-[400px] rounded-full blur-[140px]"
          style={{ background: "rgba(255,245,40,0.025)" }}
        />
        <div
          className="absolute inset-0 opacity-[0.012]"
          style={{
            backgroundImage:
              "linear-gradient(rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)",
            backgroundSize: "64px 64px",
          }}
        />
      </div>

      <main className="relative z-10 flex-1 flex flex-col items-center justify-center px-4 py-16 sm:py-10">
        <div className="w-full max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12 sm:mb-8">
            <div className="inline-flex items-center gap-3 mb-5">
              <span
                className="h-px w-6"
                style={{ background: "rgba(255,245,40,0.25)" }}
              />
              <span
                className="text-xs font-semibold tracking-[0.22em] uppercase"
                style={{ color: "rgba(255,245,40,0.45)" }}
              >
                Vupop Docs
              </span>
              <span
                className="h-px w-6"
                style={{ background: "rgba(255,245,40,0.25)" }}
              />
            </div>

            <h1 className="text-4xl sm:text-2xl md:text-3xl font-black text-white tracking-tight leading-tight mb-3">
              Choose Your <span style={{ color: "#FFF528" }}>Guide</span>
            </h1>
            <p
              className="text-sm max-w-sm mx-auto leading-relaxed"
              style={{ color: "rgba(255,255,255,0.35)" }}
            >
              Role-specific documentation for the Vupop platform.
            </p>
          </div>

          {/* Cards */}
          <div className="grid grid-cols-2 md:grid-cols-1 gap-5 sm:gap-4">
            {docs.map((doc) => (
              <div
                key={doc.route}
                onClick={() => navigate(doc.route)}
                className="group relative cursor-pointer rounded-2xl p-7 sm:p-5 transition-all duration-300 overflow-hidden"
                style={{
                  background: "#141618",
                  border: "1px solid rgba(255,255,255,0.06)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = "rgba(255,245,40,0.25)";
                  e.currentTarget.style.background = "#161a1b";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "rgba(255,255,255,0.06)";
                  e.currentTarget.style.background = "#141618";
                }}
              >
                {/* Top row */}
                <div className="flex items-start justify-between mb-5 sm:mb-4">
                  <div
                    className="p-2.5 rounded-xl"
                    style={{ background: "rgba(255,245,40,0.07)" }}
                  >
                    {doc.icon}
                  </div>
                  <span
                    className="text-xs font-semibold px-3 py-1 rounded-full"
                    style={{
                      background: "rgba(255,245,40,0.08)",
                      color: "rgba(255,245,40,0.7)",
                    }}
                  >
                    {doc.badge}
                  </span>
                </div>

                {/* Title & description */}
                <div className="mb-5 sm:mb-4">
                  <h2 className="text-xl sm:text-lg font-bold text-white mb-1.5 tracking-tight">
                    {doc.title}
                  </h2>
                  <p
                    className="text-sm leading-relaxed"
                    style={{ color: "rgba(255,255,255,0.38)" }}
                  >
                    {doc.description}
                  </p>
                </div>

                {/* Feature list */}
                <ul className="space-y-2 mb-6 sm:mb-5">
                  {doc.features.map((f) => (
                    <li
                      key={f}
                      className="flex items-center gap-2.5 text-sm"
                      style={{ color: "rgba(255,255,255,0.45)" }}
                    >
                      <span
                        className="w-1 h-1 rounded-full flex-shrink-0"
                        style={{ background: "rgba(255,245,40,0.55)" }}
                      />
                      {f}
                    </li>
                  ))}
                </ul>

                {/* Divider */}
                <div
                  className="mb-4"
                  style={{ height: 1, background: "rgba(255,255,255,0.05)" }}
                />

                {/* CTA */}
                <div
                  className="flex items-center gap-2 text-sm font-semibold"
                  style={{ color: "#FFF528" }}
                >
                  {doc.cta}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M17 8l4 4m0 0l-4 4m4-4H3"
                    />
                  </svg>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer/>
    </div>
  );
};

export default DocsLanding;
